import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderAiTariffPromoDialog = (data) => {
    openPopupHelper({
        popupName: popupNames.AI_TARIFF_PROMO,
        data,
        onClose: data.onClose,
    });
};
